<template>
  <v-container fluid ma-0 pa-0>
    <component :is="bannerComponent" />
    <Feature />
    <router-view :key="$route.fullPath"></router-view>
  </v-container>
</template>

<script>
import Banner from '@/components/default/pages/Banner.vue'
import BannerSmall from '@/components/default/pages/BannerSmall.vue'
import Feature from '@/components/default/pages/Feature.vue'

export default {
  components: {
    Banner,
    BannerSmall,
    Feature
  },
  computed: {
    bannerComponent() {
      return this.$route.path === '/' ? 'Banner' : 'BannerSmall'
    }
  }
}
</script>